import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch } from '../../../../../../redux';
import { selectPackage } from '../../../../../../redux/reducers';
import { selectAnalyticsOfferStatus, selectAnalyticsProduct } from '../../../../../../selectors/analytics';
import { selectActivePackageId, selectPackages } from '../../../../../../selectors/publishTerms';
import { Packages } from './Packages';
import { trackPackageSelect } from './tracking';
import { preparePackages } from './utils/preparePackages';

export const PackagesContainer = () => {
  const activePackageId = useSelector(selectActivePackageId);
  const packages = useSelector(selectPackages);
  const dispatch = useDispatch<TDispatch>();

  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const analyticsProduct = useSelector(selectAnalyticsProduct);

  const preparedPackages = preparePackages(packages);

  const handleChangePackage = React.useCallback(
    (newPackageId: string) => {
      const packageServiceId = packages.find(({ id }) => id === newPackageId)!.serviceId;

      trackPackageSelect({ analyticsOfferStatus, analyticsProduct, packageServiceId });

      dispatch(selectPackage(newPackageId));
    },
    [dispatch],
  );

  return <Packages value={activePackageId} packages={preparedPackages} onChange={handleChangePackage} />;
};
